/**
 * Copyright 2023-2025 Highway9 Networks Inc.
 */
import { Edge, EdgeWithPool } from "~/types/edge";
import { EdgeReference } from "~/types/site";

/**
 * True when any site edge (or selected edge-pool member) reports 5G network type.
 * MCS-3778: edge.edge.id can be undefined — guard `.startsWith`.
 */
export function siteEdgesHave5G(
  edges: EdgeReference[] | undefined,
  edgesById: Record<string, Edge | undefined>,
  edgesWithPools: EdgeWithPool[],
): boolean {
  if (!edges?.length) return false;

  const selectedEdgePoolId = edges.find((edge) => edge?.edge?.id?.startsWith("edgepool-"))?.edge?.id;
  const selectedEdgePoolTechnology = selectedEdgePoolId
    ? edgesWithPools.find((edge) => edge.edgePoolId === selectedEdgePoolId)?.networkType
    : undefined;

  return edges.some((e) => {
    const edge = e.edge.id ? edgesById[e.edge.id] : undefined;
    return edge?.networkType === "5G" || selectedEdgePoolTechnology === "5G";
  });
}
